module.exports = __webpack_public_path__ + "img/operate4.616fda71.png";